

<template>

<div class="double_arrow">


        <div v-if="StoreLongueur">
            <van-divider dashed :style="{ color: '#000000', borderColor: '#000000' }" >{{ StoreLongueur }} m</van-divider>
        </div>

</div>


<van-image v-if="StoreCableChoose"
    width="100%"
    class="img_maquette_cable"
    position="left"
    v-bind:src="StoreApi +'/images/cables/' + LoadImageCable + '.png'"
    :show-loading = false
    />

<!--
    <van-image v-if="StoreCableChoose"
    width="100%"
    
    fit="cover"
    position="left"
    v-bind:src="StoreApi +'/images/cables/' + LoadImageCable + '.png'"
    :show-loading = false
    /> 
-->

    <van-image v-if="!StoreCableChoose"
    width="100%"
    class="opacity_low img_maquette_cable"
    position="left"
    v-bind:src="StoreApi +'/images/cables/Lx_M1.png'"
    :show-loading = false
    /> 

        </template>

        <script>
        export default {
          components: {
          },
          data() {
            return {
             
            }
          },
          created(){
           
          },
          methods: {
  
            },
          computed: {
            
                /** api APP */
                StoreApi() {
                    return this.$store.state.storeGlobal.StoreApi
                },

                 /** Cable choisie ok */
                 StoreCableChoose() {
                    return this.globalFunction.existKeyInArray("reference", this.$store.state.storeCable.cable) 
                        ?  true
                        :  false
                },

                /** Type de câble */
                StoreTypeFibreCodeRef() {
                    return this.$store.state.storeCable.cable.type.TypeFibreCodeRef
                },

                /** structure de câble */
                StorePkStructureFibre() {
                    return this.$store.state.storeCable.cable.structure.pkStructureId
                },

                StoreLongueur() {
                    return this.globalFunction.existKeyInArray("longueur",  this.$store.state.storeLongueur.longueur) 
                        ?   this.$store.state.storeLongueur.longueur.longueur
                        :  false
                 },

    

                /** Type de connecteur coté A */
                StoreCodeRefCoA() {
                    return this.globalFunction.existKeyInArray("type",  this.$store.state.storeCoA.coA) 
                        ?   this.$store.state.storeCoA.coA.type.TypeCoA
                        :  ''
                },

                LoadImageCable(){
                    return this.StructureLinkImage 
                },

                DetecteCoA(){
                    if(this.StoreCodeRefCoA == "NU"){
                        return "_NU";
                    }
                    else{
                        return '';
                    }
                },

                StructureLinkImage(){
                   
                    switch (this.StorePkStructureFibre) {
                    case 7:
                        return 'Lx' + '_' + this.StoreTypeFibreCodeRef + this.DetecteCoA   ;
                    case 2:
                        return 'TB' + '_' + this.StoreTypeFibreCodeRef + this.DetecteCoA ;
                    case 10:
                        return 'Px' + this.DetecteCoA;
                    case 4:
                        return 'Px' + this.DetecteCoA;
                    default:
                        return 'no_value'
                    }

                }


          }
        
        
        }
</script>